<main class="contact-web-container wrap">
  <div class="chapeau-background"></div>
  <app-loader [isLoading]="isLoading"></app-loader>

  <!-- Bouton Retour Accueil -->
  <div class="back-home-container">
    <button routerLink="/accueil" class="back-home-btn">
      <svg viewBox="0 0 24 24" width="20" height="20" fill="currentColor">
        <path d="M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z" />
      </svg>
      <span>Retour à l'accueil</span>
    </button>
  </div>

  <section class="contact" aria-label="Contact section">
    <!-- LEFT: 2x2 cards -->
    <div class="cards" aria-label="Contact cards">
      <article class="card" role="group" aria-label="Address">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M12 2C8.686 2 6 4.686 6 8c0 4.5 6 12 6 12s6-7.5 6-12c0-3.314-2.686-6-6-6zm0 8.5A2.5 2.5 0 1 1 12 5a2.5 2.5 0 0 1 0 5.5z"
            />
          </svg>
        </div>
        <h3> Adresse</h3>
        <p>Av. de Yasser Arafat,<br />Sousse</p>
      </article>

      <article class="card" role="group" aria-label="Phone numbers">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M6.62 10.79a15.534 15.534 0 0 0 6.59 6.59l2.2-2.2a1 1 0 0 1 1.05-.24c1.12.37 2.33.57 3.54.57a1 1 0 0 1 1 1v3.48a1 1 0 0 1-1 1C10.07 22 2 13.93 2 3.5a1 1 0 0 1 1-1H6.5a1 1 0 0 1 1 1c0 1.21.2 2.42.57 3.54a1 1 0 0 1-.24 1.05l-2.21 2.2z"
            />
          </svg>
        </div>
        <h3>Numéro de téléphone</h3>
        <p>
          <a href="tel:+21629555666">+216 29 555 666</a><br />
          <a href="tel:+21624982982">+216 24 982 982</a>
        </p>
      </article>

      <article class="card" role="group" aria-label="Email">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M20 4H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2zm0 4l-8 5L4 8V6l8 5 8-5v2z"
            />
          </svg>
        </div>
        <h3> Addresse Email</h3>
        <a href="mailto:contact&#64;educanet.pro">contact&#64;educanet.pro</a>
      </article>

      <article class="card" role="group" aria-label="School">
        <div class="icon" aria-hidden="true">
          <svg viewBox="0 0 24 24">
            <path
              d="M12 3l9 4.5-9 4.5L3 7.5 12 3zm0 7.236l6-3v3.764L12 14l-6-2.999V7.236l6 3zM5 15.5L12 18l7-2.5V21H5v-5.5z"
            />
          </svg>
        </div>
        <h3> Social </h3>
        <p>
          <a
            href="https://www.facebook.com/educanet.pro/"
            target="_blank"
            class="dropdown-item"
            >Facebook</a
          >
<br>
          <a
            href="https://www.instagram.com/educanet_tunisie/"
            target="_blank"
            class="dropdown-item"
            >Instagram</a
          >
          <br>
          <a
            href="https://www.tiktok.com/@educanettn"
            target="_blank"
            class="dropdown-item"
            >tiktok</a
          >
        </p>
      </article>
    </div>

    <!-- RIGHT: Map -->
    <aside class="map-frame" aria-label="Map of Educanet">
      <iframe
        class="map"
        loading="lazy"
        allowfullscreen
        referrerpolicy="no-referrer-when-downgrade"
        src="https://www.google.com/maps?q=Educanet%20Tunisie%20Av.%20de%20Yasser%20Arafat,%20Sousse&output=embed"
      >
      </iframe>
    </aside>
  </section>
</main>

<div class="float-blob" aria-hidden="true"></div>
